export const FETCH_STARTS = 'FETCH_STARTS';
export const FETCHED_ACCOUNTS = 'FETCHED_ACCOUNTS';
export const FETCH_FAILURE = 'FETCH_FAILURE';
export const START_FETCHING_USAGE = 'START_FETCHING_USAGE';
export const FETCHED_USAGE = 'FETCHED_USAGE';
export const STOP_FETCHING_USAGE = 'STOP_FETCHING_USAGE';
export const GET_EXPIRY_DATE = 'GET_EXPIRY_DATE';
